var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waiting"},[_c('app-icon',{staticClass:"waiting-icon",attrs:{"icon":"library.unavailable"}}),_c('div',{staticClass:"waiting-info"},[_vm._v(" On "+_vm._s(_vm.waiting)+" waiting list"),(_vm.waiting !== 1)?[_vm._v("s")]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }